import { useNavigate, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import InputError from 'components/common/InputError/InputError'
import InputStyle from 'components/common/Input/Input.module.scss'
import style from './SelectCompany.module.scss'

const SelectCompany = ({ onChange, error, register }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const [companiesMatchs, setCompaniesMatchs] = useState([])

  const loadCompaniesMatchs = async (event) => {
    const value = event.target.value
    if (value.length < 3){
      setCompaniesMatchs([])
    } else {
      try{
        // const res = await api.post({
        //   url: '',
        //   data: { value },
        //   headers: { Authorization: `Bearer ${state.token}` }
        // })

        setCompaniesMatchs([
          {
            name: 'Jeanne Maré Dev',
            address: '13 rue des Artistes, 75014 Paris',
            siret: '356 268 189 00014'
          },
          {
            name: 'Jeannette',
            address: '2 rue Saint-Antoine, 50 000 Saint-lô',
            siret: '902 725 273 00032'
          },
          {
            name: 'Jeannette & Lucas',
            address: '14 avenue Tourraine, 40 088 Dax',
            siret: '718 830 153 00041'
          },
          {
            name: 'truc muche',
            address: '14 avenue de la paix, 12 345 Ici',
            siret: '314 140 754 00031'
          }
        ])
      } catch (err) {
        console.log('Failed to get matchs')
      }
    }
  }

  const selectCompany = (company) => {
    onChange(company.name)
    setCompaniesMatchs([])
  }

  return (
    <>
      <div className={classNames(InputStyle['input-wrapper'], style.addressContainer, error && InputStyle.error)}>
        <label className={classNames('input-label')} htmlFor='select'>
          {t('mainReporting:form.company.label')}
        </label>

        <input
          id='select'
          type='text'
          placeholder={t('mainReporting:form.company.placeholder')}
          {...register('company', { required: t('mainReporting:form.mandatory') })}
          onChange={loadCompaniesMatchs}
        />

        {!!companiesMatchs.length &&
          <ul>
            <li>
              <ul>
                {companiesMatchs.map((opt, id) => (
                  <li key={`option-${id}`} className={style.item} onClick={() => selectCompany(opt)}>
                    <span className={style.siret}>{opt.siret}</span>
                    {opt.name}
                    <span className={style.address}>{opt.address}</span>
                  </li>
                ))}
              </ul>
            </li>
            <li className={style.item} onClick={() => navigate('/rc-pro/oups?reason=no-company', { state })}>
              {t('mainReporting:form.company.errors.notfound')}
            </li>
          </ul>
        }
      </div>

      <InputError error={error} />
    </>
  )
}

export default SelectCompany
